const appId = 'wx4a5de02bc5d01e95'; // 微信appid
export function isLogin(data) {
  return !['439520002', '439520003', '1043950012', '1043950013'].includes(data.retcode);
}

/**
 * 获取登陆重定向地址
 * @param filter
 */
export function getLoginUrl(filter: string[]) {
  const searchStr = getFilterSearch(filter);
  return `${location.protocol}//${location.host}${location.pathname}${searchStr}${location.hash}`;
}

// 刷新code
export const refreshCode = () => {
  const redirectUrl = getLoginUrl(['code', 'state']);
  location.href = `//open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_base#wechat_redirect`;
};


// 获取seach参数obj
function getSearchParam() {
  const { search } = location; // 获取search中"?"符后的字串
  const theRequest = {};
  if (search.indexOf('?') !== -1) {
    const str = search.substr(1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      const splitArr = strs[i].split('=');
      theRequest[splitArr[0]] = unescape(splitArr[1]);
    }
  }
  return theRequest;
}

// 过滤url中的key
function getFilterSearch(filter: string[]): string {
  const searchParams = getSearchParam(); // 获取searchObj
  // 过滤filter中的key 用&拼接
  const search = Object.keys(searchParams).filter(key => filter.indexOf(key) === -1)
    .map(key => `${key}=${searchParams[key]}`)
    .join('&');
  return search ? `?${search}` : '';
}
